import { render, staticRenderFns } from "./CarouselImage.vue?vue&type=template&id=262c6dcf&scoped=true&"
import script from "./CarouselImage.vue?vue&type=script&lang=js&"
export * from "./CarouselImage.vue?vue&type=script&lang=js&"
import style0 from "./CarouselImage.vue?vue&type=style&index=0&id=262c6dcf&prod&lang=postcss&scoped=true&"
import style1 from "./CarouselImage.vue?vue&type=style&index=1&id=262c6dcf&prod&lang=postcss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "262c6dcf",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AppImg: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/common/AppImg.vue').default,SwiperNav: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/swiper-nav/SwiperNav.vue').default})
